export default function FaqForm({ form, setForm, onSubmit }) {
    return (
        <form onSubmit={onSubmit}>
            <div className="mb-2">
                <label>Pertanyaan</label>
                <input
                    className="form-control"
                    value={form.question}
                    onChange={(e) => setForm({ ...form, question: e.target.value })}
                    required
                />
            </div>
            <div className="mb-2">
                <label>Jawaban</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={form.answer}
                    onChange={(e) => setForm({ ...form, answer: e.target.value })}
                    required
                />
            </div>
            <button className="btn btn-primary">Simpan</button>
        </form>
    );
}
